import { useMatcher } from "utils/MatcherProvider";
import MDBox from "components/MDBox";
import { linearGradientStyle } from "utils/linearGradientsStyle";
import MDTypography from "components/MDTypography";
import colors from "assets/theme-dark/base/colors";
import { Title } from "../styles/Title";
import { useState } from "react";
import { Divider, IconButton, Stack, styled, useTheme } from "@mui/material";
import { DonutChart } from "./DonutChart";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

export function Summary() {
  const { palette } = useTheme();
  const { phaseHistory } = useMatcher();
  const [selectedPhase, setSelectedPhase] = useState<number>(0);

  return (
    <Container>
      <Column>
        <MDBox
          sx={{
            borderRadius: "0",
            boxShadow: "none",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            padding: "1rem",
          }}
        >
          <MDTypography mb="2rem" variant="h3">
            Summary
          </MDTypography>
          <MDTypography>
            <Title>Total matches:</Title> {phaseHistory.reduce((acc, phase) => acc + phase.matchedCount, 0)}
          </MDTypography>
          <MDTypography mb="0.5rem">
            <Title>Total duplicates:</Title> {phaseHistory.reduce((acc, phase) => acc + phase?.duplicates?.length, 0)}
          </MDTypography>
          {phaseHistory.map((phase, index) => (
            <MDTypography key={index}>
              <Title>Phase {phase.phase + 1}:</Title> {phase.matchedCount} matched, {phase.duplicateCount} duplicates
            </MDTypography>
          ))}
        </MDBox>
      </Column>
      <MDBox sx={{ alignSelf: "stretch" }}>
        <Divider orientation="vertical" />
      </MDBox>
      {phaseHistory.length > 0 && (
        <Column sx={{ flex: 1.4 }}>
          <MDTypography mb="0.5rem" variant="h4">
            Phase {selectedPhase + 1}
          </MDTypography>
          <Stack flexDirection="row" gap="1rem">
            <MyIconButton onClick={() => setSelectedPhase((current) => current - 1)} disabled={selectedPhase === 0}>
              <ArrowLeftIcon sx={{ color: colors.text.main }} />
            </MyIconButton>
            <MyIconButton
              onClick={() => setSelectedPhase((current) => current + 1)}
              disabled={selectedPhase === phaseHistory.length - 1}
            >
              <ArrowRightIcon sx={{ color: colors.text.main }} />
            </MyIconButton>
          </Stack>
          <DonutChart
            phaseData={phaseHistory[selectedPhase]}
            phaseDataBefore={phaseHistory.length > 1 && phaseHistory[phaseHistory[selectedPhase].phase - 1]}
          />
        </Column>
      )}
    </Container>
  );
}

const MyIconButton = styled(IconButton)`
  border: ${({ theme }) => `1px solid ${colors.text.main}`};
  width: 2rem;
  height: 2rem;
  border-radius: 0.25rem;
  &.Mui-disabled {
    opacity: 0.25;
  }
`;

const Container = styled(Stack)`
  flex-direction: row;
  gap: 1rem;
  flex: 1;
`;
const Column = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
